export default "__VITE_ASSET__C7CEL8ed__"